(function () {
  "use strict";
  const variantIds = new Set(["54663924416857", "59462422495577"]);
  let scheduled = false;

  function cleanLabel(text) {
    return text.replace(/\s*— PRICING V2\.1 STAGING/g, "");
  }

  function serverPrice(key, quantity) {
    const lines = window.hulkapps?.discounts?.cart?.items;
    const line = Array.isArray(lines) && lines.find(item => item.key === key && Number(item.quantity) === quantity);
    if (!line || typeof line.original_line_price_format !== "string") return null;
    const container = document.createElement("div");
    container.innerHTML = line.original_line_price_format;
    const price = container.textContent.trim();
    return /[1-9]/.test(price) ? price : null;
  }

  function updateConfiguratorItems() {
    scheduled = false;
    document.querySelectorAll(".cart__item[data-key]").forEach(item => {
      const key = item.getAttribute("data-key");
      if (!variantIds.has(key.split(":")[0])) return;
      let imageUrl = "";
      item.querySelectorAll(".cart__item--properties").forEach(prop => {
        const text = cleanLabel(prop.textContent).trim();
        if (/^Configuration Image\s*:/.test(text)) {
          imageUrl = text.replace(/^Configuration Image\s*:/, "").trim();
          prop.style.display = "none";
          return;
        }
        const walker = document.createTreeWalker(prop, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const node = walker.currentNode;
          const cleaned = cleanLabel(node.nodeValue).replace(/\[\s*\$[\d,.]+\s*\]/g, "");
          if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
        }
      });
      if (imageUrl) {
        try {
          const url = new URL(imageUrl);
          const imageContainer = item.querySelector(".cart__image");
          let image = item.querySelector(".cart__image img");
          if (url.protocol === "https:" && !image && imageContainer) {
            image = document.createElement("img");
            image.style.width = "100%";
            image.style.height = "auto";
            imageContainer.append(image);
          }
          if (url.protocol === "https:" && image && image.src !== url.href) {
            image.src = url.href;
            image.srcset = "";
            image.alt = item.querySelector(".cart__item-name")?.textContent.trim() || "";
          }
        } catch (_) {}
      }
      const quantity = Number(item.querySelector(".js-qty__num")?.value);
      const quoted = serverPrice(key, quantity);
      const price = item.querySelector(".cart__price:not(.cart__price--strikethrough)");
      if (!price) return;
      if (quoted) {
        if (price.textContent.trim() !== quoted) price.textContent = quoted;
        price.style.display = "";
        price.removeAttribute("aria-busy");
      } else if (!/[1-9]/.test(price.textContent)) {
        price.style.display = "none";
        price.setAttribute("aria-busy", "true");
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateConfiguratorItems);
  }
  function start() {
    schedule();
    new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true, characterData: true});
    document.addEventListener("cart:updated", schedule);
    document.addEventListener("cart:build", schedule);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();


/* ------------------------------------------------------------------------------
   Custom plate dimensions on the cart line - added 2026-08-28.

   Hulk Apps owns the "Custom Size" option, but its value is only the price tier
   ("1 Gang [ $50.00 ]"), so the actual inches never reached the order and the shop could
   see THAT a plate was custom but not what size to make it. The configurator sends
   customWidth / customHeight in the ADD_TO_CART payload.

   They cannot be attached before the add: Hulk builds the cart line itself and silently
   drops any properties[] input placed on the product form (verified on getswitches.com
   2026-08-28 - the injected property simply never appeared in /cart.js). So we let the add
   happen, find the line it created, and patch it with /cart/change.js, re-sending the
   line's existing properties unchanged. Hulk's pricing survives this.

   NOTE: this file has a .map, so it was compiled from a source we do not hold. If it is
   ever regenerated, re-apply this block. The same logic lives in
   snippets/ul-gate.liquid on getswitches.com and snippets/custom-code-body.liquid on
   brasshomesupply.com.
   ------------------------------------------------------------------------------ */
(function () {
  "use strict";

  var CONFIGURATOR_ORIGIN = "https://plateprestige.store";
  var PROP_NAME = "Custom Dimensions";
  var POLL_MS = 500;
  var MAX_TRIES = 40; /* ~20s, then give up */

  var pending = null;

  function twoDp(n) {
    var v = parseFloat(n);
    return isFinite(v) && v > 0 ? v.toFixed(2) : null;
  }

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); });
  }

  /* Impulse redraw. The cleanup above already listens for both of these, so firing them
     also re-runs the image/price tidy on the patched line. */
  function redrawCart() {
    try { document.dispatchEvent(new CustomEvent("cart:build")); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("cart:updated")); } catch (e) {}
  }

  window.addEventListener("message", function (event) {
    if (event.origin !== CONFIGURATOR_ORIGIN) return;
    var d = event.data;
    if (!d || d.type !== "ADD_TO_CART" || !d.payload) return;

    var w = twoDp(d.payload.customWidth);
    var h = twoDp(d.payload.customHeight);
    if (!w || !h) return; /* default size - nothing to record */

    getCart().then(function (cart) {
      pending = {
        text: w + " in W x " + h + " in H",
        before: cart.items.map(function (i) { return i.key; })
      };
      poll(0);
    }).catch(function () {});
  });

  function poll(tries) {
    if (!pending || tries > MAX_TRIES) { pending = null; return; }
    setTimeout(function () {
      getCart().then(function (cart) {
        if (!pending) return;

        /* The line this add created: a key that was not in the cart beforehand and does not
           already carry the property. Falls back to any un-stamped custom line. */
        var line = null, i, it;
        for (i = 0; i < cart.items.length; i++) {
          it = cart.items[i];
          if (pending.before.indexOf(it.key) === -1 && it.properties && !it.properties[PROP_NAME]) { line = it; break; }
        }
        if (!line) {
          for (i = 0; i < cart.items.length; i++) {
            it = cart.items[i];
            if (it.properties && it.properties["Custom Size"] && !it.properties[PROP_NAME]) { line = it; break; }
          }
        }
        if (!line) { poll(tries + 1); return; }

        var props = {}, k;
        for (k in line.properties) {
          if (Object.prototype.hasOwnProperty.call(line.properties, k)) props[k] = line.properties[k];
        }
        props[PROP_NAME] = pending.text;
        pending = null;

        return fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props })
        }).then(redrawCart);
      }).catch(function () { poll(tries + 1); });
    }, POLL_MS);
  }
})();

//# sourceMappingURL=/cdn/shop/t/29/assets/pp-configurator-cart.js.map?v=86443612630592001201787779980


(function () {
  "use strict";

  if (window.__ppCheckoutBackRecoveryInstalled) return;
  window.__ppCheckoutBackRecoveryInstalled = true;

  const checkoutSelector = [
    "input[name='checkout']:not(.hulkapps-ignore)",
    "input[value='Checkout']:not(.hulkapps-ignore)",
    "button[name='checkout']:not(.hulkapps-ignore)",
    "[href$='checkout']:not(.hulkapps-ignore)",
    "button[value='Checkout']:not(.hulkapps-ignore)",
    "input[name='goto_pp']",
    "button[name='goto_pp']",
    "input[name='goto_gc']",
    "button[name='goto_gc']",
    ".hulkapps_checkout"
  ].join(",");

  let enabledBeforeCheckout = [];

  document.addEventListener("hpo_before_checkout", function () {
    if (window.hulkapps_checkout_in_progress) return;
    enabledBeforeCheckout = Array.from(document.querySelectorAll(checkoutSelector))
      .filter(function (element) {
        return !element.hasAttribute("disabled");
      });
  });

  window.addEventListener("pageshow", function (event) {
    if (!event.persisted || window.hulkapps_checkout_in_progress !== true) return;

    window.hulkapps_checkout_in_progress = false;
    enabledBeforeCheckout.forEach(function (element) {
      if (!element.isConnected) return;
      element.removeAttribute("disabled");
      element.classList.remove("btn--loading");
    });
    enabledBeforeCheckout = [];
  });
})();

